export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.c1ce71ee.worker.js");
}
